import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function QAStats() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filterUser, setFilterUser] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchQ, setSearchQ] = useState('');

  useEffect(() => {
    fetch(`${API_URL}/api/knowledge/qa/stats`)
      .then(r => r.json())
      .then(data => {
        if (data.success) setStats(data);
      })
      .finally(() => setLoading(false));
  }, []);

  // 筛选后的记录
  const filteredRecords = (stats?.recent || []).filter(r => {
    if (filterUser && r.user !== filterUser) return false;
    if (startDate && r.time < startDate) return false;
    if (endDate && r.time > endDate + 'T23:59:59') return false;
    if (searchQ && !r.question.includes(searchQ)) return false;
    return true;
  });

  if (loading) return <div className="qa-stats-page"><p>加载中...</p></div>;

  return (
    <div className="qa-stats-page">
      <div className="qa-stats-header">
        <button onClick={() => navigate(-1)} className="btn-back">← 返回</button>
        <h2>📊 智能问答统计</h2>
      </div>

      <div className="qa-stats-grid">
        <div className="qa-stat-card">
          <h3>总提问数</h3>
          <p className="qa-stat-num">{stats?.total || 0}</p>
        </div>
        <div className="qa-stat-card">
          <h3>用户数</h3>
          <p className="qa-stat-num">{Object.keys(stats?.byUser || {}).length}</p>
        </div>
      </div>

      {/* 筛选条件 */}
      <div className="qa-filters">
        <select value={filterUser} onChange={e => setFilterUser(e.target.value)}>
          <option value="">全部用户</option>
          {Object.keys(stats?.byUser || {}).sort().map(u => (
            <option key={u} value={u}>{u}</option>
          ))}
        </select>
        <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
        <span style={{ color: '#999', lineHeight: '32px' }}>至</span>
        <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} />
        <input type="text" value={searchQ} onChange={e => setSearchQ(e.target.value)} placeholder="搜索问题..." />
        <button onClick={() => { setFilterUser(''); setStartDate(''); setEndDate(''); setSearchQ(''); }} className="btn-clear-filter">清除筛选</button>
      </div>

      {stats?.byUser && Object.keys(stats.byUser).length > 0 && (
        <div className="qa-stats-section">
          <h3>用户提问排行</h3>
          <div className="qa-user-list">
            {Object.entries(stats.byUser).sort((a,b) => b[1] - a[1]).map(([name, count]) => (
              <div key={name} className="qa-user-row">
                <span>{name}</span>
                <span className="qa-count">{count}次</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="qa-stats-section">
        <h3>提问记录（{filteredRecords.length}条）</h3>
        <div className="qa-recent-list">
          {filteredRecords.length > 0 ? filteredRecords.map((r, i) => (
            <div key={i} className="qa-recent-item">
              <div className="qa-recent-q">{r.question}</div>
              <div className="qa-recent-meta">
                <span>{r.displayName || r.realname || r.user}</span>
                <span>{new Date(r.time).toLocaleString('zh-CN')}</span>
              </div>
            </div>
          )) : <p>暂无匹配记录</p>}
        </div>
      </div>
    </div>
  );
}
